import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { diagnosesWithBodySideFormPart } from '~libs.desktop.shared.visit-medical-documents.diagnoses';

import { CertificateDetailsTextarea } from './fields/CertificateDetailsTextarea';
import {
   MedicalCertificateFormController,
   useDiagnosisSelectorDefaultItems,
   useMedicalCertificateFormController,
} from './MedicalCertificateForm.hooks';
import { StyledMedicalCertificateForm } from './MedicalCertificateForm.styled';
import { MedicalCertificateFormBean } from './MedicalCertificateForm.types';

type MedicalCertificateFormRenderer = (
   renderProps: Pick<
      MedicalCertificateFormController,
      'handleSubmit' | 'handleSubmitDraft' | 'formState' | 'markPristine'
   >
) => JSX.Element;

type MedicalCertificateFormProps = {
   readonly medicalCertificateDraft: MedicalCertificateFormBean | null;
   readonly dictionaryValidOn: Date;
   readonly visitDiagnoses: VisitDiagnosis[];
   readonly children: MedicalCertificateFormRenderer;
};

export const MedicalCertificateForm = (props: MedicalCertificateFormProps): JSX.Element => {
   const { register, handleSubmit, handleSubmitDraft, formState, markPristine } = useMedicalCertificateFormController({
      medicalCertificateDraft: props.medicalCertificateDraft,
   });

   return (
      <>
         <StyledMedicalCertificateForm autoComplete={'off'} noValidate>
            <diagnosesWithBodySideFormPart.InteractiveTable
               name={'diagnoses.value'}
               register={register}
               header={
                  <diagnosesWithBodySideFormPart.InteractiveTable.Selector
                     name={'diagnoses.selection'}
                     register={register}
                     dictionaryValidOn={props.dictionaryValidOn}
                     defaultItems={useDiagnosisSelectorDefaultItems(props.visitDiagnoses)}
                  />
               }
            />
            <CertificateDetailsTextarea register={register} />
         </StyledMedicalCertificateForm>
         {props.children({
            handleSubmit: handleSubmit,
            handleSubmitDraft: handleSubmitDraft,
            formState: formState,
            markPristine: markPristine,
         })}
      </>
   );
};
